import React, { useState } from 'react'

import { Button } from '@smarty-nx/ds'
import {
  DATA_LAYER_MODULE_TYPES,
  TRACKING_CATEGORIES,
} from '@smarty-nx/tracking'

import { ActionType, content } from './group-landing-page-cta.content'
import classes from './group-landing-page-cta.module.scss'
import {
  GroupLandingCTAType,
  GroupLandingPageCTAProps,
} from './group-landing-page-cta.types'
import { useGetUserType } from '../../../hooks'
import { triggerModuleClickEvent } from '../../../utils/dataLayer'
import { GroupPlanModal } from '../group-plan-modal'

export const GroupLandingPageCTA = ({
  buttonType,
  dataTestIdPrefix,
}: GroupLandingPageCTAProps) => {
  const userType = useGetUserType()
  const [showModal, setShowModal] = useState<boolean>(false)

  const openModal = () => setShowModal(true)
  const closeModal = () => setShowModal(false)

  const userContent = content[buttonType].actions[userType]

  return (
    <div className={classes.ctaWrapper}>
      <Button
        className={classes.groupLandingCta}
        dataTestId={`${content[buttonType].testId}${
          dataTestIdPrefix ? `-${dataTestIdPrefix}` : ''
        }`}
        dataItemCategory={TRACKING_CATEGORIES.NAVIGATION}
        dataItemName={
          buttonType === GroupLandingCTAType.EVERYONE_UNLIMITED
            ? 'get-everyone-unlimited'
            : 'get-mix-and-match'
        }
        as={(linkProps) =>
          userContent.actionType === ActionType.Link ? (
            <a
              {...linkProps}
              onClick={() => {
                // As agreed with Lydia in dmpg chat
                if (buttonType === GroupLandingCTAType.MIX_AND_MATCH) {
                  triggerModuleClickEvent(
                    buttonType,
                    DATA_LAYER_MODULE_TYPES.GROUP_PLANS,
                    'mix-and-match'
                  )
                }
                window.location.assign(userContent.url)
              }}
            >
              {content[buttonType].caption}
            </a>
          ) : (
            <a {...linkProps} onClick={openModal}>
              {content[buttonType].caption}
            </a>
          )
        }
      />
      {userContent.actionType === ActionType.ErrorModal && (
        <GroupPlanModal
          showModal={showModal}
          onHideModal={closeModal}
          modalType={userContent.modalType}
        />
      )}
    </div>
  )
}
